import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/global-board/icons/edit.svg'


const _withScopeId = n => (_pushScopeId("data-v-50b20640"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col bg-background w-full items-center h-full min-h-screen p-12"
}
const _hoisted_3 = { class: "bg-white p-12 rounded-lg w-4/6 mb-12 shadow-lg" }
const _hoisted_4 = { class: "flex flex-row justify-between items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold" }, "General Information", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: _imports_0,
  width: "16"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary" }, "Edit", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 py-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Personal Information")
], -1))
const _hoisted_10 = { class: "flex flex-col mt-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Name", -1))
const _hoisted_12 = { class: "font-thin my-5 ml-2" }
const _hoisted_13 = { class: "flex flex-row mt-4 justify-between items-start" }
const _hoisted_14 = { class: "flex flex-col w-full" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Email", -1))
const _hoisted_16 = { class: "font-thin my-5 ml-2" }
const _hoisted_17 = { class: "flex flex-col w-full" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Phone", -1))
const _hoisted_19 = { class: "font-thin my-5 ml-2" }
const _hoisted_20 = { class: "flex flex-col mt-4" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Address", -1))
const _hoisted_22 = { class: "font-thin my-5 ml-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 py-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Profile")
], -1))
const _hoisted_24 = { class: "space-y-7" }
const _hoisted_25 = { class: "flex flex-col mt-4" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Summary", -1))
const _hoisted_27 = {
  key: 0,
  class: "text-sm text-justify mt-4 ml-2"
}
const _hoisted_28 = {
  key: 1,
  class: "ml-6"
}
const _hoisted_29 = { class: "flex flex-col mt-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm mb-2" }, "Work experience", -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "flex flex-row" }
const _hoisted_34 = { class: "capitalize" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "-", -1))
const _hoisted_36 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "flex flex-row" }
const _hoisted_39 = { class: "" }
const _hoisted_40 = { class: "flex flex-col mt-4" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm mb-2" }, "Education", -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_44 = { class: "flex flex-row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "-", -1))
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "flex flex-row" }
const _hoisted_49 = { class: "flex flex-col mt-4" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm mb-2" }, "Resume", -1))
const _hoisted_51 = {
  key: 0,
  class: "w-full flex flex-row items-center py-2 px-3 border border-gray-100 shadow rounded-lg"
}
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<span class=\"\" data-v-50b20640><svg class=\"h-8 w-8 text-primary\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-50b20640><path stroke=\"none\" d=\"M0 0h24v24H0z\" data-v-50b20640></path><path d=\"M9 5H7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2V7a2 2 0 0 0 -2 -2h-2\" data-v-50b20640></path><rect x=\"9\" y=\"3\" width=\"6\" height=\"4\" rx=\"2\" data-v-50b20640></rect><path d=\"M9 14l2 2l4 -4\" data-v-50b20640></path></svg></span>", 1)
const _hoisted_53 = { class: "flex flex-col ml-2" }
const _hoisted_54 = { class: "text-xs text-gray-400 uppercase" }
const _hoisted_55 = { class: "flex flex-col mt-4" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm mb-2" }, "Other document", -1))
const _hoisted_57 = {
  key: 0,
  class: "w-full flex flex-row items-center py-2 px-3 border border-gray-100 shadow rounded-lg"
}
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<span class=\"\" data-v-50b20640><svg class=\"h-8 w-8 text-primary\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-50b20640><path stroke=\"none\" d=\"M0 0h24v24H0z\" data-v-50b20640></path><path d=\"M9 5H7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2V7a2 2 0 0 0 -2 -2h-2\" data-v-50b20640></path><rect x=\"9\" y=\"3\" width=\"6\" height=\"4\" rx=\"2\" data-v-50b20640></rect><path d=\"M9 14l2 2l4 -4\" data-v-50b20640></path></svg></span>", 1)
const _hoisted_59 = { class: "flex flex-col ml-2" }
const _hoisted_60 = { class: "flex flex-col ml-2" }
const _hoisted_61 = { class: "text-xs text-gray-400 uppercase" }
const _hoisted_62 = {
  key: 1,
  class: "ml-6"
}
const _hoisted_63 = { class: "flex flex-col mt-4" }
const _hoisted_64 = { class: "font-semibold text-sm mb-2" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Links ")
const _hoisted_66 = { class: "relative top-1" }
const _hoisted_67 = {
  key: 0,
  class: ""
}
const _hoisted_68 = ["href"]
const _hoisted_69 = {
  key: 1,
  class: "ml-6"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 mt-8" }, null, -1))
const _hoisted_71 = { class: "mt-8" }
const _hoisted_72 = { class: "flex flex-row justify-between items-center" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold" }, "Skills", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: _imports_0,
  width: "16"
}, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary" }, "Edit", -1))
const _hoisted_76 = [
  _hoisted_74,
  _hoisted_75
]
const _hoisted_77 = {
  key: 0,
  class: "flex flex-row flex-wrap mt-6"
}
const _hoisted_78 = {
  key: 1,
  class: "ml-2 text-sm text-gray-400 mt-12"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 mt-4" }, null, -1))
const _hoisted_80 = { class: "mt-8" }
const _hoisted_81 = { class: "flex flex-row justify-between items-center" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold" }, "Preferences", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: _imports_0,
  width: "16"
}, null, -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary" }, "Edit", -1))
const _hoisted_85 = [
  _hoisted_83,
  _hoisted_84
]
const _hoisted_86 = { class: "" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 py-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Expected salary")
], -1))
const _hoisted_88 = { class: "flex flex-row" }
const _hoisted_89 = { class: "mt-4 flex flex-col w-1/6" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Currency", -1))
const _hoisted_91 = { class: "mt-2 ml-6" }
const _hoisted_92 = { class: "mt-4 flex flex-col" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Salary per year", -1))
const _hoisted_94 = {
  key: 0,
  class: "mt-2 ml-6"
}
const _hoisted_95 = {
  key: 1,
  class: "mt-2 ml-6"
}
const _hoisted_96 = { class: "" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 py-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Preferred work type")
], -1))
const _hoisted_98 = { class: "mt-4" }
const _hoisted_99 = { class: "list-none" }
const _hoisted_100 = { class: "mt-12 flex justify-end" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Close", -1))
const _hoisted_102 = [
  _hoisted_101
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    (_ctx.profile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  class: "flex flex-row items-center",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.edit('general-information')))
                }, _hoisted_8)
              ]),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.profile.first_name) + " " + _toDisplayString(_ctx.profile.last_name), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.profile.email), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.profile.phone), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.profile.candidate_location
                ? _ctx.profile.candidate_location?.location?.street_address
                : "No address"), 1)
              ]),
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  (_ctx.profile.summary)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.profile.summary), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, "N/A"))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.candidate_work_histories, (work, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "flex flex-col ml-6 mb-3"
                    }, [
                      (_ctx.profile.candidate_work_histories[0].job_title === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, " N/A "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("span", _hoisted_34, _toDisplayString(new Date(work.start_date).toLocaleString("default", {
                          month: "short",
                        })) + " " + _toDisplayString(new Date(work.start_date).getFullYear()), 1),
                              _hoisted_35,
                              (!work.is_current)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(new Date(work.end_date).toLocaleString("default", {
                          month: "short",
                        })) + " " + _toDisplayString(new Date(work.end_date).getFullYear()), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_37, "Current"))
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(work.job_title) + " at " + _toDisplayString(work.company_name) + " ", 1),
                                _createElementVNode("span", _hoisted_39, "(" + _toDisplayString(_ctx.getIndustryName(work.industry)) + ")", 1)
                              ])
                            ])
                          ]))
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.candidate_education_histories, (education, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "ml-6"
                    }, [
                      (_ctx.profile.candidate_education_histories[0].degree === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, " N/A "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("span", null, _toDisplayString(new Date(education.start_date).toLocaleString(
                          "default",
                          {
                            month: "short",
                          }
                        )) + " " + _toDisplayString(new Date(education.start_date).getFullYear()), 1),
                              _hoisted_45,
                              (!education.is_current)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(new Date(education.end_date).toLocaleString("default", {
                          month: "short",
                        })) + " " + _toDisplayString(new Date(education.end_date).getFullYear()), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_47, "Current"))
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("span", null, _toDisplayString(education.degree) + " at " + _toDisplayString(education.learning_center), 1)
                            ])
                          ]))
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  (_ctx.profile?.resume?.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getFileName(_ctx.profile?.resume?.url)), 1),
                          _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.getFileExtension(_ctx.profile?.resume?.url)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  (_ctx.profile?.documents?.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getFileName(_ctx.profile?.documents?.url)), 1),
                            _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.getFileExtension(_ctx.profile?.documents?.url)), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_62, "N/A"))
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("span", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("span", _hoisted_66, [
                      _createVNode(_component_Tooltip, { message: "You can include your blog, portfolio, Github, social media profiles and any other links that show information relevant to your application." })
                    ])
                  ]),
                  (_ctx.profile?.link)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                        _createElementVNode("a", {
                          class: "",
                          target: "_blank",
                          href: _ctx.profile.link
                        }, _toDisplayString(_ctx.profile.link), 9, _hoisted_68)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_69, "N/A"))
                ])
              ])
            ]),
            _hoisted_70,
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createElementVNode("button", {
                  class: "flex flex-row items-center",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.edit('skills')))
                }, _hoisted_76)
              ]),
              (_ctx.profile.skills.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.skills, (skill, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "bg-primary-light rounded-lg px-3 py-1 text-primary m-1"
                      }, _toDisplayString(skill), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_78, "No skills added"))
            ]),
            _hoisted_79,
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _hoisted_82,
                _createElementVNode("button", {
                  class: "flex flex-row items-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit('preferences')))
                }, _hoisted_85)
              ]),
              _createElementVNode("div", _hoisted_86, [
                _hoisted_87,
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.profile?.current_salary_currency
                    ? _ctx.profile?.current_salary_currency
                    : "N/A"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    (_ctx.profile.current_salary)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_94, "$ " + _toDisplayString(_ctx.profile.current_salary), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_95, "N/A"))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_96, [
                _hoisted_97,
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("ul", _hoisted_99, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPreferredWorks(
                    _ctx.profile.preferred_work_type
                  ), (workType, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "preferred_work ml-6",
                        key: index
                      }, _toDisplayString(workType.replaceAll("_", " ")), 1))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("button", {
                class: "flex flex-row text-white justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base border-2 border-primary text-primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/')))
              }, _hoisted_102)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}